import React from 'react';

export type SharedIntersectionObserverContextType = {
    addElement: (element: any, onVisibleChanged: (visible: boolean) => void) => void;
    removeElement: (element: any) => void;
    defaultVisible: boolean;
};

export const SharedIntersectionObserverContext = React.createContext<SharedIntersectionObserverContextType>({
    addElement: () => {},
    removeElement: () => {},
    defaultVisible: true
});
